import React, { FC } from 'react'
import cx from 'classnames'

import { ActionButtonProps } from '../ActionButton'

import * as SC from './styled'

export type CardProps = {
  className?: string
  header: {
    title: string
    headerButton?: ActionButtonProps
  }
  children?: string | JSX.Element | React.ReactNode
}

const Card: FC<CardProps> = (props) => {
  const { className, header, children } = props
  const { title, headerButton } = header

  return (
    <SC.Container className={cx(className)}>
      <SC.Header>
        {headerButton && <SC.Button {...headerButton} noTextOnMobile />}
        <SC.Title>{title}</SC.Title>
      </SC.Header>
      <SC.Content>{children}</SC.Content>
    </SC.Container>
  )
}

export default Card
